import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogoutApp, getPointHistory } from "../../../api/repositories";
import { clearStorage, getDataPercipio, getDataSso } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "moment/dist/locale/id";
import { setDataNewProgram } from "../../../redux/features/notification/notificationSlice";
import { setInvalidToken } from "../../../redux/features/main/invalidTokenSlice";
import { setIsFindModule } from '../../../redux/features/main/virtualAssistSlice'
import { learningHistoryData } from "./constant";

// for translate
import { useTranslation } from "react-i18next";
import { logout, logoutSSOWithPopup } from "../../../services/authService";

const useActions = ({ loadingHeader, listJourney, setIsOpenPointHistory }) => {
  const reRenderMenu = useSelector((state) => state.localization.reRenderMenu);
  const isFindModule = useSelector((state) => state.virtualAssist.isFindModule);
  const remoteProperty = useSelector((state) => state.remote.remoteProperty);
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const localeDate = i18n.language === "en" ? "en" : "id";

  const [journeyId, setJourneyId] = useState(null);
  const [journeyName, setJourneyName] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageName, setPageName] = useState(null);
  const [contentLibraryAcademyHeader, setContentLibraryAcademyHeader] =
    useState(false);
  const [pointHistoryData, setPointHistoryData] = useState([]);

  let navigate = useNavigate();
  let location = useLocation();

  const handleLogOut = async () => {
    try {
      // Call app logout API
      const { status } = await LogoutApp();

      if (status === 200) {

        // SSO
        if(remoteProperty.isUsedSSO && !remoteProperty.isUsedPopupSSO){
          // if use SSO Redirect
          await logout();
        } else if(remoteProperty.isUsedSSO && remoteProperty.isUsedPopupSSO){
          // if use SSO Popup
          clearStorage();
          await logoutSSOWithPopup();
        }
          else {
          // Redirect user to app login page
          navigate(`${import.meta.env.BASE_URL}login`);
          
          // Clear app-related storage
          clearStorage();
        }
      }
    } catch (error) {
      // If an error occurs, still clear state for new program
      dispatch(setDataNewProgram([]));
    } finally {
      // Ensure state is cleared regardless of success or error
      dispatch(setDataNewProgram([]));
    }
  };

  const handleLogoutPercipio = () => {
    // Get Percipio logout URL from localStorage
    const percData = getDataPercipio();
    const logoutUrl = percData.url_logout;
    const isShowPercipio = percData.is_show_percipio == "true";

    const isValidUrl = (url) => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    // Open Percipio logout page in a new tab if URL exists
    if (isShowPercipio && isValidUrl(logoutUrl)) {

      const w = window.open(logoutUrl, "_blank", "width=480,height=640");

      let closed = false;

      const maxTime = 12000;
      const minTime = 3000;
      const start = Date.now();

      const interval = setInterval(() => {
        if (!w || w.closed) {
          clearInterval(interval);
          return;
        }

        const elapsed = Date.now() - start;

        // jangan tutup terlalu cepat
        if (elapsed > minTime) {
          try {
            // akses location akan throw error cross-origin
            w.location.href;
          } catch {
            // ini justru indikasi halaman sudah navigasi
            if (elapsed > maxTime) {
              w.close();
              handleLogOut();
              clearInterval(interval);
            }
          }
        }
      }, 500);
    } else {
      handleLogOut();
    }
  };

  const handlePageLocation = (locate) => {
    const path = locate.pathname;
    const page = path.split("/");

    switch (page[1]) {
      case "my-learning-journey":
        handleLocation(location);
        break;
      case "help":
        setPageName(t("feature.feature_help.header.help_center"));
        break;
      default:
        setPageName(null);
        break;
    }
    setLoading(false);
  };

  const handleLocation = (locate) => {
    const path = locate.pathname;
    const arrPath = path.indexOf("/journey/") > -1 ? path.split("/") : null;

    const id = arrPath !== null ? parseInt(arrPath[3]) : null; // index 3 id for Journey
    setJourneyId(id);

    if (arrPath === null) return;
    findJourneyName(id);
  };

  const findJourneyName = (pathId) => {
    const spreadOut = listJourney.find((item) => item.id === pathId);
    
    if(spreadOut === undefined || spreadOut === null){
      // navigate("/home");
      if(isFindModule === false) dispatch(setIsFindModule(true));
    } else {
      setJourneyName(spreadOut.name);
    }

  };

  const findContentLibraryPage = (locate) => {
    const path = locate.pathname;
    const page = path.split("/");

    if (path.indexOf("content-library") > -1 && path.indexOf("journey") > -1) {
      setContentLibraryAcademyHeader(true);
    } else {
      setContentLibraryAcademyHeader(false);
    }

    setLoading(false);
  };

  const handleFetchPointHistory = async () => {
    try {
      const { data, status } = await getPointHistory(i18n.language);
      dispatch(setInvalidToken(status));
      // const { data, status } = learningHistoryData;

      if (status === 200) {
        trimTwentyHistoryOnly(data);
      }
    } catch (err) {
      // console.log("Error fetch get Point History " + err);
      setPointHistoryData([]);
    } finally {
      setIsOpenPointHistory(true);
    }
  };

  const trimTwentyHistoryOnly = (data) => {
    if (data.length > 19) {
      // if data.length more than 19 data
      const showHistoryData = data.slice(0, 19); // trim only 19 data start from 0 to 18 (19 not included)
      const restOf = data.slice(19, data.length); // rest of data start from 19 (included) to last
      const pointRest = restOf.reduce(
        (n, { points_get }) => n + parseInt(points_get),
        0,
      );

      const lastDataOfNineteen = {
        id: 99999,
        others: true,
        points_get: parseInt(pointRest),
      };

      showHistoryData.push(lastDataOfNineteen);

      setPointHistoryData([...showHistoryData]);
    } else {
      setPointHistoryData([...data]);
    }
  };

  const dateModuleConvert = (data) => {
    return moment(data).locale(localeDate).format("DD MMM YYYY");
  };

  useEffect(() => {
    setLoading(true);
    setPageName(null);
    setJourneyId(null);
    if (loadingHeader == false) handlePageLocation(location);
    if (loadingHeader == false) findContentLibraryPage(location);
  }, [loadingHeader, location]);

  useEffect(() => {
    if (loadingHeader == false) handlePageLocation(location);
  }, [reRenderMenu]);

  return {
    handleLogoutPercipio,
    journeyId,
    journeyName,
    loading,
    pageName,
    contentLibraryAcademyHeader,
    handleFetchPointHistory,
    pointHistoryData,
    setPointHistoryData,
    dateModuleConvert,
  };
};

export default useActions;
